import {Routes} from '@angular/router';
import {isAuthenticatedGuard, redirectAuthenticatedUsersGuard} from '../core/guards/auth.guard';
import {canActivateAuthRole} from '../core/guards/auth-role.guard';
import {ForbiddenComponent} from '../forbidden/forbidden.component';
import {onboardedGuard} from '../core/guards/onboarded.guard';

export const routes: Routes = [
  {
    path: 'assets',
    loadChildren: () => import('../assets/routes').then(m => m.routes),
    canActivate: [isAuthenticatedGuard, onboardedGuard],
    canActivateChild: [isAuthenticatedGuard, onboardedGuard],
  },
  {
    path: 'billing',
    loadChildren: () => import('../billing/routes').then(m => m.routes),
    canActivate: [isAuthenticatedGuard, canActivateAuthRole, onboardedGuard],
    canActivateChild: [isAuthenticatedGuard, onboardedGuard],
    data: {
      role: 'can_read_billing',
      layout: {
        header: true,
        sidenav: true,
        footer: false
      }
    }
  },
  {
    path: 'integrations',
    loadComponent: () => import('../integrations/component').then(m => m.IntegrationsComponent),
    title: 'Integrations',
    canActivate: [isAuthenticatedGuard, onboardedGuard],
    canActivateChild: [isAuthenticatedGuard, onboardedGuard],
    data: {
      layout: {
        header: true,
        sidenav: false,
        footer: false
      }
    }
  },
  {
    path: 'overview',
    loadComponent: () => import('../overview/component').then(m => m.OverviewComponent),
    canActivate: [isAuthenticatedGuard, onboardedGuard],
    title: 'Overview',
    data: {
      layout: {
        header: true,
        sidenav: true,
        footer: false
      }
    }
  },
  {
    path: 'settings',
    loadComponent: () => import('../settings/settings.component').then(m => m.SettingsComponent),
    canActivate: [isAuthenticatedGuard, canActivateAuthRole, onboardedGuard],
    title: 'Settings',
    data: {
      role: 'can_view_settings',
      layout: {
        header: true,
        sidenav: true,
        footer: false
      }
    },
  },
  {
    path: 'search',
    loadComponent: () => import('../search/search.component').then(m => m.SearchComponent),
    canActivate: [isAuthenticatedGuard, onboardedGuard],
    title: 'Search',
    data: {
      layout: {
        header: true,
        sidenav: true,
        footer: false
      }
    },
  },
  {
    path: 'org',
    loadChildren: () => import('../org/routes').then(m => m.routes),
    canActivate: [isAuthenticatedGuard],
    canActivateChild: [isAuthenticatedGuard],
  },
  {
    path: 'forbidden',
    loadComponent: () => ForbiddenComponent,
    data: {
      layout: {
        header: true,
        sidenav: true,
        footer: false
      }
    }
  },
  {
    path: 'tos',
    loadComponent: () => import('../tos/tos.component').then(m => m.TosComponent),
    data: {
      layout: {
        header: false,
        sidenav: false,
        footer: false
      }
    },
    pathMatch: 'full',
    title: 'TrackStream | Terms of Service',
  },
  {
    path: 'privacy',
    loadComponent: () => import('../tos/pp.component').then(m => m.PrivacyPolicyComponent),
    data: {
      layout: {
        header: false,
        sidenav: false,
        footer: false
      }
    },
    pathMatch: 'full',
    title: 'TrackStream | Privacy Policy',
  },
  {
    path: '',
    loadChildren: () => import('../landing-page/route').then(m => m.landingRoute),
    canActivate: [redirectAuthenticatedUsersGuard],
    canActivateChild: [redirectAuthenticatedUsersGuard],
  },
  {
    path: '**',
    redirectTo: '',
  }
];
